export default () => {
  return (
    <>
      <h1>403</h1>
    </>
  );
};
